import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";

const BreRulesAgentList = () => {
  const navigate = useNavigate();
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isActiveFilter, setIsActiveFilter] = useState("");
  const [editingRuleId, setEditingRuleId] = useState(null);
  const [editedCriteria, setEditedCriteria] = useState("");

  // Fetch rules on mount or when filter changes
  useEffect(() => {
    fetchRules();
  }, [isActiveFilter]);

  const fetchRules = async () => {
    try {
      setLoading(true);
      const url = isActiveFilter
        ? `${URL.RULE_AGENT}/getAll?isActive=${isActiveFilter}`
        : `${URL.RULE_AGENT}/getAll`;
      const response = await axiosInstance.get(url);
      setRules(response.data || []);
    } catch (err) {
      console.error("Error fetching BRE Agent rules:", err);
      alert("Failed to fetch rules. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Toggle active/inactive status
  const toggleActive = async (rule) => {
    try {
      const updatedActive = rule.isActive === 1 ? 0 : 1;
      const response = await axiosInstance.post(
        `${URL.RULE_AGENT}/updateAgentPolicy?id=${rule.id}`,
        {
          isActive: updatedActive,
        }
      );

      // Update table
      setRules((prev) =>
        prev.map((r) =>
          r.id === rule.id ? { ...r, isActive: response.data.isActive } : r
        )
      );
    } catch (err) {
      console.error("Error updating active status:", err);
      alert("Failed to update status. Please try again.");
    }
  };

  // Start editing criteria
  const startEditingCriteria = (rule) => {
    setEditingRuleId(rule.id);
    setEditedCriteria(rule.criteria || "");
  };

  // Save criteria
  const saveCriteria = async (rule) => {
    try {
      const response = await axiosInstance.post(
        `${URL.RULE_AGENT}/updateAgentPolicy?id=${rule.id}`,
        {
          criteria: editedCriteria,
        }
      );

      setRules((prev) =>
        prev.map((r) =>
          r.id === rule.id ? { ...r, criteria: response.data.criteria } : r
        )
      );

      setEditingRuleId(null);
      setEditedCriteria("");
    } catch (err) {
      console.error("Error updating criteria:", err);
      alert("Failed to update criteria. Please try again.");
    }
  };

  return (
    <div className="container mt-4">
      {/* Back Button */}
      <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* Header & Filter */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>EDI BRE Rules</h4>
        <select
          className="form-select w-auto"
          value={isActiveFilter}
          onChange={(e) => setIsActiveFilter(e.target.value)}
        >
          <option value="">All</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </div>

      {/* Table / Loading */}
      {loading ? (
        <p>Loading...</p>
      ) : rules.length === 0 ? (
        <p>No rules found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="thead-light">
              <tr>
                <th>Sequence</th>
                <th>Policy Name</th>
                <th>Rule Name</th>
                <th>Criteria</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {rules.map((rule) => (
                <tr key={rule.id}>
                  <td>{rule.sequence}</td>
                  <td>{rule.policyName}</td>
                  <td>{rule.ruleName}</td>

                  {/* Criteria cell */}
                  <td
                    style={{
                      cursor: rule.criteria ? "pointer" : "not-allowed",
                      color: !rule.criteria ? "#888" : "inherit",
                    }}
                    onClick={() => rule.criteria && startEditingCriteria(rule)}
                  >
                    {editingRuleId === rule.id ? (
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control form-control-sm me-2"
                          value={editedCriteria}
                          onChange={(e) => setEditedCriteria(e.target.value)}
                        />
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => saveCriteria(rule)}
                        >
                          Save
                        </button>
                      </div>
                    ) : (
                      rule.criteria || <span className="text-muted">N/A</span>
                    )}
                  </td>

                  {/* Active tick */}
                  <td
                    className="text-center align-middle"
                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                    title="Click to toggle"
                    onClick={() => toggleActive(rule)}
                  >
                    {rule.isActive === 1 ? "✔️" : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BreRulesAgentList;
